import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { getLocaleFromPath, buildLocalePath, SupportedLocale } from './routing';

/**
 * Hook to get the current active locale from the URL
 */
export function useActiveLocale(): SupportedLocale {
  const location = useLocation();
  return getLocaleFromPath(location.pathname);
}

/**
 * Hook to build paths for the current locale
 */
export function useLocalePath() {
  const locale = useActiveLocale();
  
  return useCallback((path: string) => {
    return buildLocalePath(locale, path);
  }, [locale]);
}
